import React from "react";
import CategorySlider from "../CategorySlider/CategorySlider";
import CollectionList from "../CollectionList/CollectionList";
import { Link } from "react-router-dom";
import Snow from "../Snow/Snow";
export default function Categories() {
  return (
    <>
    /{/* <Snow /> */}
      <div className="container mt-5">
        <div className="mb-4 text-xl text-center">
          <Link
            to="/custom"
            className="inline-block explore-btn px-6 py-3 rounded-lg transition-colors duration-300 shadow-md"
          >
            Create your own Custom Item ➕ 🎨
          </Link>
        </div>
        <CollectionList />
      </div>
    </>
  );
}
